export default __webpack_public_path__ + "static/media/back.b7e570c6.png";